import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/index.less';
import permission from './directive/permission';


import './permission'; // permission control
import {getDicts} from '@/api/system/data';
import Pagination from '@/components/Pagination/index.vue';
import { dateFormat } from '@/utils/utils';


Vue.prototype.dateFormat = dateFormat;
Vue.prototype.getDicts = getDicts;
// 全局组件挂载
Vue.component('Pagination', Pagination);
Vue.use(permission);

Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
